/**
 * @namespace TeaserImpression
 * @aka PIANO.TeaserImpression
 *
 */
PIANO.TeaserImpression = function (window, document) {

  /**
   * @type Array
   */
  var _observedElements = [];

  /**
   *
   * @param {Element} elementTeaser
   */
  var trackTeaserImpression = function (elementTeaser) {
    var elementTracking = elementTeaser.querySelector('script[data-spy=piano]');
    if (null === elementTracking) {
      return;
    }

    try {
      var trackingOptions = JSON.parse(elementTracking.textContent);
    } catch (e) {
      return;
    }

    var teaserPlayer = 'false';
    var teaserMedia = '';
    if (elementTeaser.classList.contains('teaser-mediaplayer')) {
      teaserPlayer = 'true';
      var mediaElement = elementTeaser.querySelector('[data-spy=teaser-mediaplayer]');
      if (null !== mediaElement) {
        if (mediaElement.classList.contains('video')) {
          teaserMedia = 'Video';
        } else if (mediaElement.classList.contains('audio')) {
          teaserMedia = 'Audio';
        }
      }
    }

    var impressionData = {
      'onsitead_type': 'Publisher',
      'onsitead_advertiser': trackingOptions.onsitead_advertiser,
      'onsitead_campaign': PIANO.Utils.getPageInformation('contentId'),
      'onsitead_category': '',
      'onsitead_creation': trackingOptions.onsitead_creation,
      'onsitead_detailed_placement': '',
      'onsitead_format': '',
      'onsitead_general_placement': '0',
      'onsitead_url': trackingOptions.onsitead_url,
      'onsitead_variant': '',
      'onsitead_teaser_bar_name': trackingOptions.onsitead_teaser_bar_name,
      'onsitead_teaser_bar_id': '',
      'onsitead_recommender': trackingOptions.onsitead_recommender,
      'onsitead_recommender_model': '',
      'onsitead_teaser_player': teaserPlayer,
      'onsitead_teaser_media': teaserMedia
    };

    PIANO.Queue.push({
      name: 'publisher.impression',
      data: impressionData
    });
  }

  /**
   *
   * @param entries
   * @private
   */
  var _onIntersection = function _onIntersection(entries) {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio >= 0.7) {
        var element = entry.target;

        _intersectionUnobserveElement(element);

        if (!PIANO.Utils.isEnabled()) {
          return;
        }

        // console.debug('Tracking Piano TeaserImpression: .teaser is intersecting', element);

        trackTeaserImpression(element);
      }
    })
  }

  /**
   *
   * @return {*[]}
   * @private
   */
  var _buildThresholdList = function _buildThresholdList() {
    var thresholds = [];
    var numSteps = 20

    for (var i = 1.0; i <= numSteps; i++) {
      var ratio = i / numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  }

  /**
   *
   * @type {{root, rootMargin: string, threshold: *[]}}
   * @private
   */
  var _intersectionObserverOptions = {
    root: null,
    rootMargin: '0px',
    threshold: _buildThresholdList()
  };

  /**
   *
   * @type {IntersectionObserver}
   * @private
   */
  var _intersectionObserver = new window.IntersectionObserver(_onIntersection, _intersectionObserverOptions);

  /**
   *
   * @private
   */
  var _intersectionUnobserve = function () {
    _observedElements.forEach(function (element) {
      _intersectionObserver.unobserve(element);
    })
    _observedElements = [];
  }

  /**
   *
   * @param element
   * @private
   */
  var _intersectionUnobserveElement = function (element) {
    try {
      _intersectionObserver.unobserve(element);
    } catch (exception) {
      /* noop */
    }

    try {
      var i = _observedElements.indexOf(element);
      if (i > -1) {
        _observedElements.splice(i, 1);
      }
    } catch (exception) {
      /* noop */
    }
  }

  /**
   *
   * @private
   */
  var _intersectionObserve = function () {
    /**
     *
     * @type {NodeListOf<Element>}
     * @private
     */
    var _elements = document.querySelectorAll('.teaser');

    _elements.forEach(function (_element) {
      _intersectionObserver.observe(_element);
      _observedElements.push(_element);
    })
  }

  document.addEventListener('piano:pushstate', function (event) {
    _intersectionUnobserve();

    var blockNo = 0;
    var elementsContainerRow = document.querySelectorAll('.container > .row');
    elementsContainerRow.forEach(function (elementContainerRow) {
      var elementsTeaser = elementContainerRow.querySelectorAll('.teaser');
      if (0 === elementsTeaser.length) {
        return;
      }
      blockNo++;

      var title = blockNo + '. Block: ';

      var isRecommendedContent = '';
      try {
        isRecommendedContent = elementContainerRow.parentNode.parentNode.classList.contains('recommended-content') ? 'C2C' : '';
      } catch (exception) {
      }

      var containerHeadlineElement = elementContainerRow.querySelector('.row > h2,.row > h3,.row > h1, .row .section-label')
      if (!containerHeadlineElement) {
        title += 'ohne Überschrift';
      } else {
        title += containerHeadlineElement.textContent.trim();
      }

      elementsTeaser.forEach(function (elementTeaser) {
        var elementTracking = elementTeaser.querySelector('script[data-spy=piano]');
        if (null === elementTracking) {
          return;
        }

        try {
          var trackingOptions = JSON.parse(elementTracking.textContent);
        } catch (exception) {
          return;
        }

        trackingOptions.onsitead_teaser_bar_name = title;
        if (!trackingOptions.hasOwnProperty('onsitead_recommender')) {
          trackingOptions.onsitead_recommender = isRecommendedContent.toString(); //boolean als String ist wichtig
        }
        elementTracking.textContent = JSON.stringify(trackingOptions);
      })
    });

    _intersectionObserve();
  });
  _intersectionObserve();

  /**
   * --------------------------------------------------------------------------
   * Public Pageview Api
   * --------------------------------------------------------------------------
   */
  return {};

}(window, document);
